import { useEffect, useRef, useState } from 'react'
import { postWithAuth } from '../common'
import { toast } from 'react-toastify'

const invalidateRequests = sequence => { sequence.current++ }

// Keep summaries out of editable forms; an older selection cannot replace a newer one.
export default function useRecordSelection(endpoint, orgId, onLoaded) {
    const [value, setValue] = useState('')
    const sequence = useRef(0)
    useEffect(() => {
        invalidateRequests(sequence)
        setValue('')
        return () => invalidateRequests(sequence)
    }, [orgId])
    const select = async next => {
        const request = ++sequence.current
        if (!next?._listOnly) { setValue(next); return }
        try {
            const result = await postWithAuth(endpoint, { orgId, recordId: next.id })
            if (result?.err || !result?.data?.[0]) throw new Error(result?.err || 'Record could not be loaded.')
            if (sequence.current !== request) return
            onLoaded?.(result.data[0])
            setValue(result.data[0])
        } catch (error) { if (sequence.current === request) toast.error(error.message) }
    }
    return [value, select]
}
